import React from 'react';
import PropTypes from 'prop-types';
import { PostedJobsFilter as PostedJobsFilterComponent } from './PostedJobsFilter';

export const PostedJobsFilter = ({ postedAfter, postedBefore }) => (
  <div>
    <PostedJobsFilterComponent
      date={postedAfter.date}
      label={postedAfter.label}
      dateType={postedAfter.dateType}
      setFilters={postedAfter.setFilters}
    />
    <PostedJobsFilterComponent
      date={postedBefore.date}
      label={postedBefore.label}
      dateType={postedBefore.dateType}
      setFilters={postedBefore.setFilters}
    />
  </div>
);

PostedJobsFilter.propTypes = {
  postedAfter: PropTypes.object.isRequired,
  postedBefore: PropTypes.object.isRequired,
};

export default PostedJobsFilter;
